import { Component, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { PubService } from '../../../services/pub.service';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-view-pubs',
    imports: [CommonModule],
    templateUrl: './view-pubs.component.html',
    styleUrls: ['./view-pubs.component.css']
})
export class ViewPubsComponent implements OnInit {

  listing: any = null;
  loading = true;
  error = '';

  constructor(private pubService: PubService, private route: ActivatedRoute) { }

  async ngOnInit() {
    const id = this.route.snapshot.paramMap.get('id');

    if (!id) {
      this.error = "Invalid item ID.";
      this.loading = false;
      return;
    }

    try {
      this.listing = await firstValueFrom(this.pubService.get(id));
    } catch {
      this.error = "Failed to load item.";
    } finally {
      this.loading = false;
    }
  }

  private parseNumber(v: any): number {
    if (v === null || v === undefined) return 0;
    const cleaned = String(v).replace(/[^\d.-]+/g, '');
    const n = Number(cleaned);
    return isNaN(n) ? 0 : n;
  }
  isDiscounted(): boolean {
    if (!this.listing) return false;
    const price = this.parseNumber(this.listing.price);
    const offer = this.parseNumber(this.listing.listingPrice);
    return offer > 0 && offer < price;
  }
  showDiscountBadge(): boolean {
    if (!this.listing) return false;
    const d = Number(this.listing.discount);
    return !isNaN(d) && d > 0;
  }
  getSiteName(url: string): string {
    if (!url) return '';
    try {
      let hostname = new URL(url).hostname.toLowerCase();
      hostname = hostname.replace('www.', '');
      const parts = hostname.split('.');
      let siteName = parts[0];
      siteName = siteName.charAt(0).toUpperCase() + siteName.slice(1);
      return siteName;
    } catch {
      return '';
    }
  }
}
